import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../../../../services/state-management/storage.service/storage.service';

export const checkRoleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageService = inject(StorageService);

  const userData = JSON.parse(storageService.getUserData('userData') || '{}');

  const userRole = userData?.role || 'GUEST';
  const requiredRole = route.data?.['role'];


  if (requiredRole.includes(userRole) || userRole === "ADMIN") {
    return true;
  }

  switch (userRole) {
    case 'AUDIENCE':
      return router.parseUrl('/gallery/explore');
    case 'ARTIST':
      return router.parseUrl('/gallery/uploads');
    default:
      return router.parseUrl('/gallery/explore');
  }
};
